import { useEffect, useMemo, useState } from "react";
import { TranslationService } from "../../../../services/TranslationService";
import { ValidationMessage } from "../../../shared/RequieredManager";
import { EditProps } from "../EditAction";
import { Field } from "./FieldHelpers";
import WhatsappService, {
  WhatsappTemplateListType
} from "../../../../services/WhatsappService";
import CompanyService, { Entities } from "../../../../services/CompanyService";
import {
  EntityField,
  sortEntityFields
} from "../../../shared/entities/EntityField";
import {
  ClientFields,
  getClientFieldTitle
} from "../../../../services/ClientService";
import { ToastService } from "../../../shared/bootstrap/Toast";

export const WhatsAppTemplateContent = (propsEdit: EditProps) => {
  const { propGen: props, data } = propsEdit;
  const [templatesData, setTemplatesData] =
    useState<WhatsappTemplateListType>();

  const fixedFieldsCustomer = useMemo(() => {
    const clientFieldOptions = [
      ...CompanyService.getAdditionalDefinitionsFiltered(Entities.Client).map(
        (x) => new EntityField(x)
      )
    ]
      .sort(sortEntityFields(CompanyService.getPersonSortedFields().split(",")))
      .map((x) => ({ value: x.id.toString(), text: x?.title ?? "" }));

    const insertFieldOptions = [
      { text: TranslationService.translate.InsertField, value: "" },
      ...WhatsappService.getConfigItemsByWhatsApp().map((cl) => ({
        value: cl.toString(),
        text: getClientFieldTitle(cl as ClientFields)
      })),
      ...clientFieldOptions
    ];
    return insertFieldOptions;
  }, []);

  useEffect(() => {
    const getWhatsappTemplateList = async () => {
      const result = await WhatsappService.getList();
      if (result instanceof Error) {
        ToastService.showToast(
          "Error al obtener templates",
          undefined,
          "danger"
        );
        return;
      } else {
        setTemplatesData(result);
      }
    };
    getWhatsappTemplateList();
  }, []);

  // Procesar el contenido si hay un template seleccionado
  const processedContent = useMemo(() => {
    let contentData = data.Content;

    // Procesar formato especial con ---
    if (contentData) {
      const partes = contentData.split("---");
      const primeraParte = partes[0] || "";
      const numeroPrimeraParte = parseFloat(primeraParte);
      const esNumero =
        !isNaN(numeroPrimeraParte) && isFinite(numeroPrimeraParte);
      if (esNumero && partes.length > 1) {
        contentData = partes.slice(1).join("---");
      }
    }

    // Procesar reemplazo de números por nombres de campos
    if (contentData && data.WATemplateID && templatesData?.list) {
      const template = templatesData.list.find(
        (t) => t.WATemplateID === Number(data.WATemplateID)
      );
      if (template && template.FieldList) {
        const dataParameters = template.Parameters;
        const elements = Array.from(
          { length: dataParameters || 0 },
          (_, index) => index + 1
        );
        let texto = contentData;

        const fieldListArray = template.FieldList.split(",");
        elements.forEach((elIndex) => {
          const param = elIndex;
          const fieldValue = fieldListArray[param - 1];
          if (fieldValue) {
            const fieldText = fixedFieldsCustomer.find(
              (f) => f.value === fieldValue.trim()
            )?.text;
            if (fieldText) {
              texto = texto.replace(
                new RegExp(`\\{\\{${param}\\}\\}`, "g"),
                `{{${fieldText}}}`
              );
            }
          }
        });

        return texto;
      }
    }

    return contentData;
  }, [data.Content, data.WATemplateID, templatesData, fixedFieldsCustomer]);

  return (
    <div className="row">
      {processedContent && data.WATemplateID && (
        <Field title={TranslationService.translate.template} colClass="col-8">
          <textarea
            disabled
            className="form-control"
            value={processedContent}
            onChange={(e) =>
              props.str.required("Content").onChange(e.target.value)
            }
            style={{ resize: "none" }}
            rows={6}
          />
          <ValidationMessage
            {...props.str.required("Content")}
            message={TranslationService.translate.EnterBodyWhatsApp}
          />
        </Field>
      )}
    </div>
  );
};
